import {
  FunctionComponent,
  MouseEventHandler,
  MouseEvent,
  MutableRefObject
} from 'react'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { dismissPopover } from 'services/OverlayService'
import IconButton from '@mui/material/IconButton'
import TealToolTip from 'components/TealToolTip'

const PDFButton: FunctionComponent<PDFButtonProps> = ({
  pdfUrl,
  isLogged,
  setSignUpModalIsOpen
}: PDFButtonProps) => {
  const handleOnClick: MouseEventHandler<HTMLButtonElement> = (e: MouseEvent<HTMLElement>) => {
    dismissPopover(e.target)
    e.preventDefault()
    e.stopPropagation()
    setSignUpModalIsOpen(true)
  }

  return (
    <div className='mh2 mh1-m'>
      <TealToolTip title='Download PDF' placement='top' arrow={false} bgColor='dark'>
        <IconButton
          size='small'
          data-event-category='Download'
          data-event-action='PDF'
          data-event-label={pdfUrl}
          classes={{ root: 'black', sizeSmall: 'f3 f4-t f5-m' }}
          {...(isLogged
            ? {
                href: pdfUrl,
                download: true
              }
            : {
                onClick: handleOnClick
              })}
        >
          <PictureAsPdfIcon fontSize='inherit' className='vm' />
        </IconButton>
      </TealToolTip>
    </div>
  )
}

interface PDFButtonProps {
  pdfUrl: string
  hidden: MutableRefObject<any>
  isLogged: boolean
  setSignUpModalIsOpen: (value: boolean) => void
}

export default PDFButton
